import React from 'react';
import {
    Box,
    Button,
    InputAdornment,
    TextField,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
    CheckCircleRounded,
    PaymentRounded,
} from "@mui/icons-material";
import { toPriceWithComma, toPriceWithoutComma } from "../../../helper/utils";

const _ChargeAmountPresets = ({
    suggests,
    rawAmount,
    amountToPay,
    SetAmountToPay,
}) => {
    function handleAmountChange(e) {
        const val = toPriceWithoutComma(e.target.value);
        SetAmountToPay(val);
    }

    return (
        <>
            {/* 1. Quick Presets */}
            {suggests && suggests.length > 0 && (
                <Box>
                    <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary', display: 'block', mb: 1.5 }}>
                        بسته‌های شارژ پیشنهادی:
                    </Typography>
                    <Grid container spacing={1.5}>
                        {suggests.map((item, index) => {
                            const isSelected = rawAmount === item.Amount;
                            return (
                                <Grid key={index} size={{ xs: 6, sm: 4, md: 3 }}>
                                    <Button
                                        fullWidth
                                        variant={isSelected ? "contained" : "outlined"}
                                        onClick={() => SetAmountToPay(item.Amount.toString())}
                                        startIcon={isSelected ? <CheckCircleRounded sx={{ ml: 0.5, fontSize: 16 }} /> : null}
                                        sx={{
                                            borderRadius: 2.8,
                                            py: 1.2,
                                            fontWeight: 800,
                                            fontSize: '0.85rem',
                                            borderColor: isSelected ? 'primary.main' : 'divider',
                                            bgcolor: isSelected ? 'primary.main' : 'background.paper',
                                            color: isSelected ? 'white' : 'text.primary',
                                            boxShadow: isSelected ? '0 4px 12px rgba(28, 139, 156, 0.25)' : 'none',
                                            '&:hover': {
                                                borderColor: 'primary.main',
                                                bgcolor: isSelected ? 'primary.dark' : 'rgba(28, 139, 156, 0.04)'
                                            }
                                        }}
                                    >
                                        {toPriceWithComma(item.Amount)} تومان
                                    </Button>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Box>
            )}

            {/* 2. Custom Amount Input */}
            <Box>
                <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary', display: 'block', mb: 1 }}>
                    یا مبلغ دلخواه مورد نظر:
                </Typography>
                <TextField
                    fullWidth
                    placeholder="حداقل ۵۰۰،۰۰۰ تومان"
                    value={amountToPay ? toPriceWithComma(amountToPay) : ""}
                    onChange={handleAmountChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <PaymentRounded sx={{ color: 'text.secondary', fontSize: 20 }} />
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="end">
                                <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.secondary' }}>
                                    تومان
                                </Typography>
                            </InputAdornment>
                        ),
                        sx: { borderRadius: 2.8, fontSize: '1.05rem', fontWeight: 800 }
                    }}
                    helperText="حداقل مبلغ جهت افزایش شارژ کیف پول، ۵۰۰،۰۰۰ تومان می‌باشد"
                />
            </Box>
        </>
    );
};

export default _ChargeAmountPresets;
